import { LANG_EN, LANG_ES } from "@/constants/Language";

const filterLevelsByLanguage = (sortedLevels, lang) => {
  const spanishLevels = sortedLevels.filter(
    (level) => level.language === LANG_ES,
  );
  const englishLevels = sortedLevels.filter(
    (level) => level.language === LANG_EN,
  );

  switch (lang) {
    case LANG_EN:
      return englishLevels;
    case LANG_ES:
      return spanishLevels;
    default:
      return sortedLevels;
  }
};

export default filterLevelsByLanguage;
